import { ReactNode, useContext, useEffect } from 'react'
import { withRouter } from 'react-router-dom'
import * as H from 'history'
import { useState } from 'react'
import { GlobalStateContext } from 'contexts/global_state_context'
import { Flex } from './flex'
import Aside from './aside'
import { ThemeContext } from 'contexts/theme_context'

type LayoutProps = {
    children?: ReactNode
    history: H.History
}
const Layout = (props: LayoutProps): JSX.Element => {
    const globalState = useContext(GlobalStateContext)
    const [mode, setMode] = useState<'Experiment' | 'Device' | 'Inspection'>('Experiment')
    const [collapsed, setCollapsed] = useState(false)
    const theme = useContext(ThemeContext)
    const isHomeTest = !!process.env.REACT_APP_IS_HOME_TEST

    useEffect(() => {
        if (props.history.location.pathname.match('device')) {
            setMode('Device')
        } else if (props.history.location.pathname.match('inspection') || props.history.location.pathname.match('freezers')) {
            setMode('Inspection')
        } else if (props.history.location.pathname.match('transcription')) {
            return
        } else {
            setMode('Experiment')
        }
    }, [props.history.location.pathname])

    return (
        <Flex id="layout" style={{ height: '100vh', overflow: 'hidden', position: 'relative' }}>
            <Aside collapsed={collapsed} history={props.history} />
            <div className="content" style={{ height: '100vh', overflowY: 'scroll', minWidth: '800px' }}>
                {props.children}
            </div>
        </Flex>
    )
}

export default withRouter(Layout)
